module.exports = __webpack_public_path__ + "img/icon_wht_close.39a4d557.png";